import { useEffect } from 'react';

// Lista de imágenes críticas para precargar
const CRITICAL_IMAGES = [
  '/assets/images/app-usuario-home.png',
  '/assets/images/trineo-icon-192.png',
  '/assets/images/carlos.jpg',
  '/assets/images/ana.jpg',
  '/assets/images/miguel.jpg'
];

// Función para precargar una imagen
const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

// Función para precargar múltiples imágenes
const preloadImages = async (imageList) => {
  try {
    const preloadPromises = imageList.map(src => preloadImage(src));
    await Promise.allSettled(preloadPromises);
    console.log('Imágenes precargadas exitosamente');
  } catch (error) {
    console.warn('Error precargando imágenes:', error);
  }
};

// Hook para precargar imágenes
export const useImagePreloader = (imageList = CRITICAL_IMAGES) => {
  useEffect(() => {
    preloadImages(imageList);
  }, [imageList]);
};

// Componente para precargar automáticamente imágenes críticas
const ImagePreloader = ({ customImages = [] }) => {
  const allImages = [...CRITICAL_IMAGES, ...customImages];
  useImagePreloader(allImages);
  return null;
};

export default ImagePreloader; 